/* eslint-disable @typescript-eslint/ban-ts-comment */
import 'react-toastify/dist/ReactToastify.css';
import * as Sentry from '@sentry/react';
import SentryFallback from '../pages/error/sentry-fallback';
import 'intersection-observer';
import {
  posthogApiKey,
  posthogOptions,
} from '@seller-hermes/app/globals';
import {
  StoreProvider as BaseStoreProvider,
  useStoreRehydrated,
} from 'easy-peasy';
import ThemeDeps from '@seller-hermes/app/theme-deps';
import { GlobalStyles } from '@seller-hermes/theme/global';
import {
  queryClient,
  store,
  router,
} from '@seller-hermes/app/globals';
import FullscreenLoading from '@seller-hermes/features/ui/FullscreenLoading/fullscreen-loading.component';
import Toaster from '@seller-hermes/features/ui-v2/Toaster';
import ShadcnToaster from '@seller-hermes/features/ui-v2/Sonner';
import Tooltip from '@seller-hermes/features/ui-v2/Tooltip';
import 'intersection-observer';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6';
import * as React from 'react';
import { Suspense } from 'react';
import { I18nextProvider } from 'react-i18next';
import { QueryClientProvider } from 'react-query';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { RecoilRoot } from 'recoil';
import i18n from '../i18n/config';
import Headers from './headers';
import DevRouteBadge from '@seller-hermes/features/dev-route/dev-route-badge.component';
import { PostHogProviderWithUser } from './PostHogProviderWithUser';

const StoreProvider = BaseStoreProvider as any;

// Rotas públicas (sem auth) que NÃO devem aguardar a hidratação do
// store easy-peasy. Atualmente: TRP-trail (`/trp/dispute/:token`) — a
// transportadora não tem sessão Cognito, então o store nunca rehidrata
// de forma autenticada e a página ficaria em FullscreenLoading pra
// sempre. Para essas rotas, renderizamos os children direto.
const PUBLIC_ROUTE_PREFIXES = ['/trp/dispute/'];
function isPublicRoute(): boolean {
  if (typeof window === 'undefined') return false;
  return PUBLIC_ROUTE_PREFIXES.some((p) =>
    window.location.pathname.startsWith(p),
  );
}

function WaitForStateRehydration({ children }) {
  const isRehydrated = useStoreRehydrated();
  if (isPublicRoute()) return children;
  return isRehydrated ? children : <FullscreenLoading isLoading />;
}

const Deps: React.FC = () => {
  return (
    <StoreProvider store={store}>
      <PostHogProviderWithUser apiKey={posthogApiKey} options={posthogOptions}>
        <I18nextProvider i18n={i18n}>
          <RecoilRoot>
            <Sentry.ErrorBoundary fallback={SentryFallback}>
                <QueryClientProvider client={queryClient}>
                  <ThemeDeps>
                    <WaitForStateRehydration>
                      <Suspense fallback={<FullscreenLoading isLoading />}>
                        <Tooltip.Provider delayDuration={0}>
                          <NuqsAdapter>
                            <RouterProvider router={router} />
                          </NuqsAdapter>
                        </Tooltip.Provider>
                      </Suspense>
                    </WaitForStateRehydration>
                    <GlobalStyles />
                    <Headers />
                    <DevRouteBadge />
                  </ThemeDeps>
                  <ToastContainer />
                  <Toaster />
                  <ShadcnToaster richColors />
                </QueryClientProvider>
             
            </Sentry.ErrorBoundary>
          </RecoilRoot>
        </I18nextProvider>
      </PostHogProviderWithUser>
    </StoreProvider>
  );
};

export default Deps;
